import { Form } from 'antd'
import { MomentDatePicker } from '@gravitate-js/excalibrr'
import moment from 'moment'
import React, { useRef } from 'react'

export function DatePickerInput({
  editable,
  name,
  message,
  initialValue = '',
  required = false,
  className = '',
  size = 'small',
  format = 'MM-DD-YYYY',
  ...others
}) {
  if (!editable) return initialValue

  return (
    <div>
      <Form.Item name={name} noStyle rules={[{ required, message: { message } }]}>
        <SmartDatePicker format={format} className={className} size={size} {...others} />
      </Form.Item>
    </div>
  )
}

function SmartDatePicker({ value, className, size, ...others }) {
  const momentDate = moment(value)
  momentDate?.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })

  return value != null ? (
    <MomentDatePicker value={momentDate} {...others} className={className} size={size} />
  ) : (
    <MomentDatePicker className={className} {...others} />
  )
}
